//Job
export const GET_FORMS = "/api/forms";

// User
export const GET_USER = "/api/user";
export const GET_USERS = "/api/user";
export const CREATE_USER = "/api/user";
export const CREATE_USERS = "/api/user";
export const DELETE_USER = "/api/user";
export const UPDATE_USER = "/api/user";
export const LIST_USERS = "/api/user/listing";

// Role
export const GET_ROLE = "/api/role";
export const GET_ROLES = "/api/role";
export const CREATE_ROLE = "/api/role";
export const UPDATE_ROLE = "/api/role";
export const DELETE_ROLE = "/api/role";
export const LIST_ROLES = "/api/role/listing";

// Module
export const GET_MODULES = "/api/module";

// Permissions
export const GET_PERMISSIONS = "/api/permission";

// Group
export const GET_USER_GROUP = "/api/usergroup";
export const LIST_GROUPS = "/api/usergroup/listing";

// Candidate
export const GET_CANDIDATE = "/api/candidates";

// Job
export const GET_JOB = "/api/job";

// Job TIme line
export const GET_JOB_TIMELINE = "/api/jobtimeline";

export const GET_JOB_CANDIDATE_STAGE = "/api/jobcandidatestage";

// Benefits
export const BENEFITS = "/api/benefits";

// Documents
export const DOCUMENT_API = "/api/documents";

// Preassessment
export const GET_PREASSESSMENT = "/api/pre-assessment";